import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent
} from '@mui/material';
import StatementTemplateSelector from './StatementTemplateSelector';
import WitnessStatementForm from './WitnessStatementForm';

/**
 * CreateStatementDialog - Reusable component for creating witness statements from events
 *
 * Flow:
 * 1. Shows template selector
 * 2. On template selection, shows statement form
 * 3. On save/cancel, closes and calls onComplete
 *
 * @param {boolean} open - Whether dialog is open
 * @param {Object} event - Event object with eventId and metadata
 * @param {Function} onClose - Called when dialog closes
 * @param {Function} onComplete - Called when statement is created/saved
 */
export default function CreateStatementDialog({ open, event, onClose, onComplete }) {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
  };

  const handleStatementSaved = () => {
    setSelectedTemplate(null);
    if (onComplete) {
      onComplete();
    }
    onClose();
  };

  const handleCancel = () => {
    setSelectedTemplate(null);
    onClose();
  };

  return (
    <>
      {/* Template Selector Dialog */}
      <Dialog
        open={open && !selectedTemplate}
        onClose={handleCancel}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Select Statement Template</DialogTitle>
        <DialogContent>
          <StatementTemplateSelector
            onSelect={handleTemplateSelect}
            onCancel={handleCancel}
          />
        </DialogContent>
      </Dialog>

      {/* Statement Form Dialog */}
      <Dialog
        open={open && !!selectedTemplate}
        onClose={handleCancel}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Create Witness Statement</DialogTitle>
        <DialogContent>
          <WitnessStatementForm
            template={selectedTemplate}
            statement={null}
            eventData={event}
            onSave={handleStatementSaved}
            onCancel={handleCancel}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
